module.exports = __webpack_public_path__ + "static/media/featureIconFour.3fb77f82.webp";